function Analytics(props) {
  return (
    <div>
      <h2>Analytics</h2>
    </div>
  );
}

export default Analytics;
